import ROUTES from '../routers/routes'
import config from '../config/config.json'
const ROUTESVIEW = [
  {
    name: ROUTES.HOME.name,
    pathname: ROUTES.HOME.pathname,
    icon: ROUTES.HOME.icon,
    childrens: null,
  },
  /* {
    name: ROUTES.OPERATIONS.name,
    pathname: ROUTES.OPERATIONS.pathname,
    icon: ROUTES.OPERATIONS.icon,
    roles: ROUTES.OPERATIONS.roles,
    childrens: [
      {
        name: ROUTES.OPERATIONS_GENERAL.name,
        pathname: ROUTES.OPERATIONS_GENERAL.pathname,
        roles: ROUTES.OPERATIONS_GENERAL.roles,
      }, */
      // { name: 'Desembolso', pathname: ROUTES.CONSTRUCTION.pathname },
      // { name: 'Financiero', pathname: ROUTES.CONSTRUCTION.pathname },
      // { name: 'Documentos', pathname: ROUTES.CONSTRUCTION.pathname },
      // { name: 'Notificaciones', pathname: ROUTES.CONSTRUCTION.pathname },
      /* {
        name: ROUTES.OPERATIONS_REQUESTS.name,
        pathname: ROUTES.OPERATIONS_REQUESTS.pathname,
        roles: ROUTES.OPERATIONS_REQUESTS.roles,
      },
      {
        name: ROUTES.OPERATIONS_INVESTMENTS.name,
        pathname: ROUTES.OPERATIONS_INVESTMENTS.pathname,
        roles: ROUTES.OPERATIONS_INVESTMENTS.roles,
      },
      {
        name: ROUTES.OPERATIONS_ACQUISITIONS.name,
        pathname: ROUTES.OPERATIONS_ACQUISITIONS.pathname,
        roles: ROUTES.OPERATIONS_ACQUISITIONS.roles,
      },
    ],
  }, */
  // {
  //   name: 'Notificaciones',
  //   pathname: ROUTES.CONSTRUCTION.pathname,
  //   icon: 'majesticons:pencil-alt-line',
  //   childrens: null,
  // },
  // {
  //   name: 'Solicitudes',
  //   pathname: ROUTES.CONSTRUCTION.pathname,
  //   icon: 'akar-icons:bell',
  //   childrens: null,
  // },
  // {
  //   name: 'Fondeos',
  //   pathname: ROUTES.CONSTRUCTION.pathname,
  //   icon: 'ant-design:bar-chart-outlined',
  //   childrens: null,
  // },
  // {
  //   name: 'Productos',
  //   pathname: ROUTES.CONSTRUCTION.pathname,
  //   icon: 'gg:product-hunt',
  //   childrens: null,
  // },
  /* {
    name: ROUTES.ADMIN.name,
    pathname: ROUTES.ADMIN.pathname,
    icon: ROUTES.ADMIN.icon,
    roles: ROUTES.ADMIN.roles,
    childrens: [
      {
        name: ROUTES.USER_DETAIL_INTERNAL.name,
        pathname: ROUTES.USER_DETAIL_INTERNAL.pathname,
        roles: ROUTES.USER_DETAIL_INTERNAL.roles,
      },
      {
        name: ROUTES.USER_DETAIL_EXTERNAL.name,
        pathname: ROUTES.USER_DETAIL_EXTERNAL.pathname,
        roles: ROUTES.USER_DETAIL_EXTERNAL.roles,
      },
    ],
  }, */
  // {
  //   name: 'Ayuda',
  //   pathname: ROUTES.CONSTRUCTION.pathname,
  //   icon: 'ci:help-circle-outline',
  //   childrens: null,
  // },
  /* {
    name: ROUTES.DESEMBOLSOS.name,
    pathname: ROUTES.DESEMBOLSOS.pathname,
    icon: ROUTES.DESEMBOLSOS.icon,
    roles: ROUTES.DESEMBOLSOS.roles,
    childrens: [
      {
        name: ROUTES.CONSULTA_DESEMBOLSOS.name,
        pathname: ROUTES.CONSULTA_DESEMBOLSOS.pathname,
        roles: ROUTES.CONSULTA_DESEMBOLSOS.roles,
      },
      {
        name: ROUTES.CREAR_SOLICITUD_DESEMBOLSOS.name,
        pathname: ROUTES.CREAR_SOLICITUD_DESEMBOLSOS.pathname,
        roles: ROUTES.CREAR_SOLICITUD_DESEMBOLSOS.roles,
      },
    ],
  }, */
]
export const ROUTESSIDEBAR = () => {
  return ROUTESVIEW.filter(
    (view) => {
      const arrview = view.pathname.split('/')
      if(config.REACT_APP_DOMAIN === 2){
        return !arrview.includes(['administracion','desembolsos'])
      }else{
        return ROUTESVIEW
      }
    },
  )
}